import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';

import { IRouterProps } from '@interfaces/App.interface';
import { generateGlobalColumns, generateEntityColumn, IDataGridConfig } from '@ts/storybook';
import { IConfigComponent, CLabel, COrganization, CRole, CUser } from '@ts/ui-models';

interface IRoleAssignmentProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'organizationAcls',
  aclId: 'taXUsersRoles',
  entity: 'acl',
  fetchURL: '/api/organizationAcls',
  crudURL: '/api/organizationAcl',
  //mainClass: CLabel,
};

const RoleAssignment = (props: IRoleAssignmentProps) => {
  const { configComponent = defaultConfigComponent, inheritedProps } = props;

  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false, organization: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      generateEntityColumn(
        { field: 'organization' },
        { tEntity: 'role', field: 'organization', mainClass: COrganization },
        { inheritedProps }
      ),
      generateEntityColumn({ field: 'role' }, { field: 'role', mainClass: CRole }, { inheritedProps }),
      generateEntityColumn({ field: 'user' }, { field: 'user', mainClass: CUser }, { inheritedProps }),
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      customDeleteModal={{ message: 'This will also erase associations related to the item' }}
      inheritedProps={inheritedProps}
    />
  );
};

export default RoleAssignment;

/* import React, { useState } from 'react';
import _ from 'lodash';
import withRouter from '@utils/wrappers/WithRouter';
import { withTranslation } from 'react-i18next';
import TableV3 from '@modules/tableV3/TableV3';

const RoleAssignment = props => {
  const [state, setState] = useState({
    filter: props.transferPropsRoute.query,
  });

  //#region Functions
  const _getColumns = () => {
    return [
      {
        fnLabel: () => props.t('ID'),
        name: 'id',
        fHidden: true,
      },
      {
        fnLabel: () => props.t('Organization'),
        name: 'organization',
        fHidden: true,
        rawValue(acl) {
          return acl.get('role').get('organization');
        },
        filterValue(o, organization) {
          return `${o.get('role').get('organization').get('name')} ${organization}`;
        },
        sortValue(o, organization) {
          return organization;
        },
        render: (o, organization, fnFilter) => {
          return organization.get('name');
        },
      },
      {
        fnLabel: () => props.t('User'),
        name: 'user',
        rawValue(acl) {
          return acl.get('user');
        },
        filterValue(o, name) {
          return `${o.get('user').get('login')} ${name}`;
        },
        sortValue(o, name) {
          return name;
        },
        render: (o, user, fnFilter) => {
          return user.get('login');
        },
      },
      {
        fnLabel: () => props.t('Role'),
        name: 'role',
        rawValue(acl) {
          return acl.get('role');
        },
        filterValue(o, role) {
          return `${o.get('role').get('name')} ${role}`;
        },
        sortValue(o, role) {
          return role;
        },
        render: (o, role, fnFilter) => {
          return `${role.get('name')} at ${role.get('organization').get('name')}`;
        },
      },
    ];
  };
  //#endregion

  return (
    <TableV3
      {...props}
      title={'Role to User'}
      componentId={'organizationAcls'}
      aclId="taXUsersRoles"
      //editDataPath="editOrganizationAcl"
      fnChange={props.fnChange}
      crudURL={'/api/organizationAcl'}
      editUrl={'/acl'}
      columns={_getColumns()}
      pkColumn={'id'}
      itemsFetchUrl={'/api/organizationAcls'}
      fnFilter={filter => setState({ ...state, filter })}
      //entity="roles"
      downloadOptions={{
        enable: true,
        fields: [
          {
            label: 'User',
            value(row) {
              return row.user.login;
            },
          },
          {
            label: 'Role',
            value(row) {
              return `${row.role.name} at ${row.role.organization.name}`;
            },
          },
        ],
      }}
    />
  );
};

export default withRouter(withTranslation()(RoleAssignment));
 */
